import { Injectable } from '@angular/core';
import { ListingOption, ListingOptionResponse, OptionValue, OptionValueResponse } from '../models/inModels/MarketPlaceModel';
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from './authentication/authentication.service';
import { LoggingService } from './logging/logging.service';
import { LazyLoadEvent } from '../models/DataTables/lazyLoadEvent';

@Injectable()
export class ListingOptionsService {
  private baseUrl = '/api/marketplace/listing/options';

  constructor(private http: HttpClient,
        private auth: AuthenticationService,
        private logging: LoggingService
  ) {}

  search(model: LazyLoadEvent): Promise<any> {
    return this.http.post<any>(`${this.auth.apiUrl}${this.baseUrl}/search`, JSON.stringify(model), { headers: this.auth.header }).toPromise()
          .then(response => response as any)
          .catch(error => this.logging.handleError(error));
  }

  create(model: ListingOption): Promise<ListingOptionResponse> {
    return this.http.post<ListingOptionResponse>(`${this.auth.apiUrl}${this.baseUrl}/create`, JSON.stringify(model), { headers: this.auth.header }).toPromise()
          .then(response => response as ListingOptionResponse)
          .catch(error => this.logging.handleError(error));
  }

  get(id: number): Promise<ListingOptionResponse> {
    return this.http.get<ListingOptionResponse>(`${this.auth.apiUrl}${this.baseUrl}/get/${id}`, { headers: this.auth.header }).toPromise()
          .then(response => response as ListingOptionResponse)
          .catch(error => this.logging.handleError(error));
  }

  update(model: ListingOption): Promise<ListingOptionResponse> {
    return this.http.post<ListingOptionResponse>(`${this.auth.apiUrl}${this.baseUrl}/update`, JSON.stringify(model), { headers: this.auth.header }).toPromise()
          .then(response => response as ListingOptionResponse)
          .catch(error => this.logging.handleError(error));
  }

  updateOptionValue(model: OptionValue): Promise<OptionValueResponse> {
    return this.http.post<OptionValueResponse>(`${this.auth.apiUrl}${this.baseUrl}/optionvalue/update`, JSON.stringify(model), { headers: this.auth.header }).toPromise()
          .then(response => response as OptionValueResponse)
          .catch(error => this.logging.handleError(error));
  }

  createOptionValue(model: OptionValue): Promise<OptionValueResponse> {
    return this.http.post<OptionValueResponse>(`${this.auth.apiUrl}${this.baseUrl}/optionvalue/create`, JSON.stringify(model), { headers: this.auth.header }).toPromise()
          .then(response => response as OptionValueResponse)
          .catch(error => this.logging.handleError(error));
  }

  deleteOptionValue(id: number): Promise<void> {
    return this.http.get<void>(`${this.auth.apiUrl}${this.baseUrl}/optionvalue/delete/${id}`, { headers: this.auth.header }).toPromise()
          .then(response => response as void)
          .catch(error => this.logging.handleError(error));
  }


  deleteListingValue(id: number): Promise<void> {
    return this.http.get<void>(`${this.auth.apiUrl}${this.baseUrl}/listingvalue/delete/${id}`, { headers: this.auth.header }).toPromise()
          .then(response => response as void)
          .catch(error => this.logging.handleError(error));
  }

  delete(id: number): Promise<void> {
    return this.http.get<void>(`${this.auth.apiUrl}${this.baseUrl}/delete/${id}`, { headers: this.auth.header }).toPromise()
          .then(response => response as void)
          .catch(error => this.logging.handleError(error));
  }
}


// WEBPACK FOOTER //
// ./src/app/services/listing-options.service.ts